import React from 'react';
import { connect } from 'react-redux';
import styles from './Common.module.css'
import { PatientCareCenterNoteChargesGroupRow } from './GroupRow';

class PatientCareCenterNoteChargesGroupModalities extends React.Component {

    render() {
        if (this.props.activities.length > 0) {
            return (
                <div>
                    <div className={styles.row}>
                        <span className={styles.col1} >
                            <b>Modalities</b>
                        </span>
                        <span className={styles.col2}>
                            <div className={styles.int_field}>
                            </div>
                        </span>
                    </div>

                    {Object.keys(this.props.activities)
                        .map(key => {
                            const act = this.props.activities[key];
                            return (
                                <PatientCareCenterNoteChargesGroupRow
                                    key={act.id}
                                    id={act.id}
                                    table='MLMODALITIES'
                                    prefix='XLMD'
                                    noteId={this.props.noteId}
                                    activity={act.activity}
                                    selected={act.selected}
                                />

                            )
                        })
                    }

                </div>
            );
        } else {
            return (<span />);
        }
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));


    // (code >= 97032 && code <= 97542 && code != 97150) || (code >= 97760 && code <= 97762)


    let activities = Object.keys(state.entities.notes.MLMODALITIES)
        .filter(key => {
            return (state.entities.notes.MLMODALITIES[key].XLMDXLNO === xlno &&
                state.entities.notes.MLMODALITIES[key].XLMDPERFORMED === true
                &&
                Object.keys(state.entities.masterData.MLMASTERMODALITIES)
                    .find(x => {
                        if (state.entities.masterData.MLMASTERMODALITIES[x].MDNO === state.entities.notes.MLMODALITIES[key].XLMDMDNO) {
                            var code = parseInt(state.entities.masterData.MLMASTERMODALITIES[x].MDCODE);
                            if (!isNaN(code)) { // IS number
                                // (code >= 97032 && code <= 97542 && code != 97150) || (code >= 97760 && code <= 97762)
                                if ((code >= 97032 && code <= 97542 && code !== 97150) || (code >= 97760 && code <= 97762)) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    })

            )
        })
        .sort((a, b) => state.entities.notes.MLMODALITIES[a].XLMDNO - state.entities.notes.MLMODALITIES[b].XLMDNO)
        .map(key => {
            let act = state.entities.notes.MLMODALITIES[key].XLMDMDNO ?
                state.entities.masterData.MLMASTERMODALITIES[state.entities.notes.MLMODALITIES[key].XLMDMDNO].MDNAME + ' - ' +
                state.entities.masterData.MLMASTERMODALITIES[state.entities.notes.MLMODALITIES[key].XLMDMDNO].MDCODE + ' - ' : '<Activity Not Defined> - ';
            act += state.entities.notes.MLMODALITIES[key].XLMDACTIVITY ?
                ' - ' + state.entities.notes.MLMODALITIES[key].XLMDACTIVITY : '';
            return {
                activity: act,
                id: state.entities.notes.MLMODALITIES[key].XLMDNO,
                selected: state.entities.notes.MLMODALITIES[key].XLMDISGROUP
            };
        });


    return {
        noteId,
        noteType,
        xlno,
        activities
    };
}

const connectedPatientCareCenterNoteChargesGroupModalities = connect(mapStateToProps)(PatientCareCenterNoteChargesGroupModalities);
export { connectedPatientCareCenterNoteChargesGroupModalities as PatientCareCenterNoteChargesGroupModalities };

